import baseRoute from '../baseRoute';

export default `${baseRoute}/orders` as const;
